    /* eslint max-statements:0 */
    angular.module('qkr').controller('MerchantAdminController', merchantAdminController);
    function merchantAdminController($scope,
                                     $rootScope,
                                     merchantService,
                                     appConfig,
                                     messageService,
                                     appUrl,
                                     $location,
                                     $window,
                                     checkBrowserService,
                                     $uibModal,
                                     $routeSegment,
                                     integrationConstant,
                                     integrationViewService,
                                     integrationSettingsService,
                                     integrationHelperService) {
        const merchantCtrl = this;

        merchantCtrl.username = appConfig.username;
        merchantCtrl.displayUnsupportedBrowserAlert = appConfig.displayUnsupportedBrowserAlert;
        merchantCtrl.isPartner = appConfig.isPartner;
        $scope.shouldShowReports = false;

        const init = function() {
            if (merchantCtrl.displayUnsupportedBrowserAlert) {
                if (checkBrowserService.isUnsupportedBrowser()) {
                    const modalInstance = $uibModal.open({
                        template: require('../../templates/browserAlertDialog.html'),
                        controller: 'BrowserAlertController',
                        windowClass: 'fade',
                        backdrop: 'static',
                        resolve: {
                        }
                    });

                    modalInstance.result.then((result) => {
                        if (result) {
                        }
                    }, () => {});
                }
            }

            const merchantInfoResponse = (response) => {
                merchantCtrl.merchant = response;
                // new integration settings, old code rules
                merchantCtrl.integratrationPath = '#' + integrationConstant.LOCATION.merchantAdmin.value;
                const businessCategory =  response['businessCategory'] || {};
                merchantCtrl.isIntegrationVisible = integrationViewService
                    .isIntegrationSetAvailableForBizCat(businessCategory.name);
                const flattenData = integrationHelperService.convertServerDataToFlatten(merchantCtrl.merchant);
                 merchantCtrl.isPos = integrationSettingsService.integrationDetails(flattenData).isPos;
                // end new integration settings

                if(response.businessCategory) {
                    merchantCtrl.isSeatingMapVisible = false;
                    $scope.shouldShowReports = !(businessCategory.name === "School"
                        || businessCategory.name === "Supplier"
                        || (merchantCtrl.isPartner && (merchantCtrl.merchant.partner ?
                        merchantCtrl.merchant.partner.disableReportView : false)));
                } else {
                    messageService.warning('There is not business category');
                }
            };

            merchantService.loadMerchantInfo()
                .then(merchantInfoResponse,
                    (reason) => {
                        messageService.error('merchant load ', reason);
                    }
                );
        };

        merchantCtrl.adminList = appConfig.contextPath + appUrl.mcAdmin;

        merchantCtrl.containRole = function(role) {
            return appConfig.userRoles.indexOf(role) !== -1;
        };

        $rootScope.$on('merchantInfoChanged', (evt) => {
            merchantService.refreshMerchantInfo().then(
                    (response) => {
                        merchantCtrl.merchant = response;
                        const flattenData = integrationHelperService.convertServerDataToFlatten(merchantCtrl.merchant);
                        $scope.isPos = integrationSettingsService.integrationDetails(flattenData).isPos;
                    },
                    (reason) => {
                        messageService.error('merchant load ', reason);
                    }
                );
        });

        merchantCtrl.hideProduct = function() {
            return merchantService.behaviour(merchantCtrl.merchant, 'adminPage.hideProduct');
        };

        merchantCtrl.hideOptionSet = function() {
            return merchantService.behaviour(merchantCtrl.merchant, 'adminPage.hideOptionSet');
        };

        merchantCtrl.hideMenus = function() {
            return merchantService.behaviour(merchantCtrl.merchant, 'adminPage.hideMenus');
        };

        merchantCtrl.hideInventoryTab = function() {
            return merchantService.behaviour(merchantCtrl.merchant, 'adminPage.hideInventoryTab');
        };

        merchantCtrl.hideMarketingTab = function() {
            return merchantService.behaviour(merchantCtrl.merchant, 'adminPage.hideMarketingTab');
        };

        merchantCtrl.hideCoupons = function() {
            return merchantService.behaviour(merchantCtrl.merchant, 'adminPage.hideCoupons');
        };

        merchantCtrl.hideSeatingMap = function() {
            return merchantService.behaviour(merchantCtrl.merchant, 'adminPage.hideSeatingMap');
        };

        merchantCtrl.hidePaymentGateway = function() {
            return merchantService.behaviour(merchantCtrl.merchant, 'adminPage.hidePaymentGateway');
        };

        merchantCtrl.hideTaxSettings = function() {
            return merchantService.behaviour(merchantCtrl.merchant, 'adminPage.hideTaxSettings');
        };

        $scope.fetchDocument = function(resourceName, type) {
            var appLocale = appConfig.locale
            if(!appLocale ) {
                appLocale = 'en-gb'
            }

            // temporary change for GDPR, until server is ready
            const path =  appConfig.contextPath + '/temporaryPrivacy?locale='+appLocale;

            $window.open(path, '_blank');
        };

        // Clicking Products menu on sidebar force to reload product page when user is already on product page
        merchantCtrl.loadProductsPage = function() {
            if ($routeSegment.startsWith('inventory')) {
                $routeSegment.chain[0].reload();
            } else {
                $location.path('/inventory');
            }
        };

        // When your view loads, so does its associated controller.
        // Instead of using ng-init, simply call your init()  Since your controller runs before ng-init
        init();
    }



// WEBPACK FOOTER //
// ./src/controllers/merchant/merchant.admin.controller.js